import Swal from "sweetalert2";
export const keeperToast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  width: 360,
  timer: 5000,
  showClass: {
    popup: "animate__animated animate__fadeInDown",
  },
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});
